import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart } from 'react-chartjs-2';
import { Chart as ChartJS, registerables } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

const MultiTypeChart = ({ chartData, options, height = 300, maintainAspectRatio }: any): JSX.Element => {
  return (
    <div style={{ height: `${height}px`, position: 'relative' }}>
      <Chart type="bar" data={chartData} options={{
        ...options,
        maintainAspectRatio: maintainAspectRatio === 'sales' ? true : false,
        responsive: true,
      }} />;
    </div>
  )
};

export default MultiTypeChart;
